import React from 'react'

import "./Loader.css";

const Loader = () => {
  return (
    <div className='back'>
    <div class="content">
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
</div>
</div>

  )
}

export default Loader
